import ApiClient, { ShopifyResponse } from './client';
import {
  ShopifyCartResponse,
  ShopifyProductResponse,
  ShopifyProductVariantResponse,
 } from "./types";
import { getShopifyCustomerId } from './utils';

export {
  ShopifyResponse,
  ShopifyCartResponse,
  ShopifyProductResponse,
  ShopifyProductVariantResponse,
  getShopifyCustomerId
};

export default ApiClient;
